import { connect } from 'react-redux'
import PauseScreen from './PauseScreen'
import {togglePause} from '../../actions/exam';

const mapStateToProps = (state, ownProps) => {
  return {
    nbQuestions: state.exam.questions.length,
    currentQuestion: state.exam.currentQuestion + 1,
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    togglePause: () => dispatch(togglePause())
  };
};

const PauseScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PauseScreen);

export default PauseScreenContainer
